import React from 'react';

import { createStylesHook, PhaseSection } from 'shared';
import i18next from 'core/i18n';
import { MatriculaAnalysisDetails, MatriculaAnalysisDetailsProps } from './MatriculaAnalysisDetails';

const useStyles = createStylesHook({
  card: {
    padding: '24px 0 0 0 !important'
  },
  header: {
    padding: '0 24px !important'
  }
});

export interface MatriculaAnalysisSectionProps extends MatriculaAnalysisDetailsProps {}

export const MatriculaAnalysisSection: React.FunctionComponent<MatriculaAnalysisSectionProps> = ({
  analysisInfo,
  includedInFormalization,
  canEditMatriculaFormalization
}) => {
  const matriculas = analysisInfo?.matriculas || [];

  /**
   * Styles
   */
  const classes = useStyles();

  return (
    <PhaseSection
      title={i18next.t('matriculaAnalysis')}
      subtitle={!!matriculas.length ? i18next.t('addAndEditReview') : ''}
      classes={{ card: classes.card, header: classes.header }}
    >
      <MatriculaAnalysisDetails
        analysisInfo={analysisInfo}
        includedInFormalization={includedInFormalization}
        canEditMatriculaFormalization={canEditMatriculaFormalization}
      />
    </PhaseSection>
  );
};
